module.exports = __webpack_public_path__ + "img/wheelchair-move.ffe0351c.svg";